import React, { FC } from 'react';
import { SmartformElementData } from '../../types';
import { getElementFields } from '../../forms/utils/getElementFields';
import { ConditionalField } from '../../fields/ConditionalField/ConditionalField';

export const ConditionalElement: FC<React.PropsWithChildren<SmartformElementData>> = (props) => {
  const [conditionalField] = getElementFields(props).required;
  return (
    <ConditionalField
      name={conditionalField.name}
      helpText={conditionalField.helpText}
      label={conditionalField.label}
      required={conditionalField.validation.required}
      errors={conditionalField.error}
      touched={conditionalField.touched}
      type="button"
    />
  );
};

export default ConditionalElement;
